export function getSelectedRatePlans(state) {
  return state.basket.map(item => ({ unitTypeId: item.unitTypeId, ratePlanId: item.ratePlanId }))
}

export function getBookingEngineIdInBasket(state) {
  if (state.basket.length === 0) {
    return null
  }

  return state.basket[0].bookingEngineId
}

export { getReceipt } from './utils/getReceipt'
export { getServiceCostsBeforeTax } from './utils/getServiceCostsBeforeTax'
export { getServiceCosts } from './utils/getServiceCosts'
export { getTotalCost } from './utils/getTotalCost'
export { getPrePaymentDetails } from './utils/getPrePaymentDetails'
